import * as R from "ramda";
import { toPath } from "./resource";
import { AButton } from "./resources/aButton";
import { Background } from "./resources/background";
import { BackgroundPerson } from "./resources/backgroundPerson";
import { BButton } from "./resources/bButton";
import { CButton } from "./resources/cButton";
import { Grey } from "./resources/grey";
import { Person } from "./resources/person";
import { Shade } from "./resources/shade";
import { Title } from "./resources/title";
export { AButton, Background, BackgroundPerson, BButton, CButton, Grey, Person, Shade, Title, };
export const resourcePaths = R.map(toPath, [
    ...R.compose(R.map((n) => `sheet${n}.png`), R.range)(0, 6),
    ...R.compose(R.map((n) => `sheet${n}.json`), R.range)(0, 6),
    ...R.compose(R.map((n) => `sheet-person${n}.png`), R.range)(0, 7),
    ...R.compose(R.map((n) => `sheet-person${n}.json`), R.range)(0, 7),
]);
//# sourceMappingURL=resources.js.map